export const USER_LOGGED_IN = 'user_logged_in'
